app.controller('stateOfHealthGeneralAllergiesController', ['$scope', '$state', '$mdDialog', '$translate', 'patientModel', 'allergyModel', 'userModel',
    function ($scope, $state, $mdDialog, $translate, patientModel, allergyModel, userModel) {

        function setData() {
            $scope.currentUserId = userModel.currentUser.id;
        }

        function setPermissions() {
        }

        function setListeners() {
        }

        function setActions() {
            $scope.addAllergy = function() {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/stateOfHealth/popup-allergy.html',
                    controller: 'popupAllergyCreateController'
                })
                .then(function (data) {
                    patientModel.getStateOfHealth($state.params.patientId).then($scope.listeners.onStateOfHealthLoad);
                }, function () {
                    //cancel
                });
            };

            $scope.updateAllergy = function(allergy, previewOnly) {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/stateOfHealth/popup-allergy.html',
                    controller: 'popupAllergyUpdateController',
                    resolve: {
                        allergyToUpdate: function() {
                            return allergy;
                        },
                        preview: function() {
                            return previewOnly;
                        }
                    }
                })
                .then(function (data) {
                    patientModel.getStateOfHealth($state.params.patientId).then($scope.listeners.onStateOfHealthLoad);
                }, function () {
                    //cancel
                });
            };

            $scope.deleteAllergy = function(allergy) {
                var label = $translate.instant('T.ENUM.ALLERGY_TYPE.' + allergy.type);
                if(allergy.notes) {
                    label += ' (' + allergy.notes + ')';
                }
                var configPopup = {
                    templateUrl: 'edm/application/view/app/patient/popup/stateOfHealth/popup-delete-confirmation.html',
                    controller: 'popupDeleteWithReasonController',
                    controllerAs: 'deleteConfirmCtrl',
                    skipHide: true,
                    locals: {
                        labels: label,
                        item: angular.copy(allergy),
                        userModel: userModel,
                        $mdDialog: $mdDialog,
                        message: 'T.MODULE.PATIENT.ALLERGY_DELETE_CONFIRMATION'
                    }
                };

                $mdDialog.show(configPopup).then(function(data) {
                    allergyModel.update(data);
                    var successWatcherDisabler = $scope.$on(Event.ALLERGY.UPDATE.SUCCESS, function (event, result) {
                        successWatcherDisabler();
                        errorWatcherDisabler();
                        patientModel.getStateOfHealth($state.params.patientId).then($scope.listeners.onStateOfHealthLoad);
                    });

                    var errorWatcherDisabler = $scope.$on(Event.ALLERGY.UPDATE.ERROR, function (event, error) {
                        successWatcherDisabler();
                        errorWatcherDisabler();
                    });
                });
            };

            $scope.userHasAccessToDeleteEntity = function(entity) {
                return !entity.deleted && (entity.author.id === $scope.currentUserId || (entity.author.userType === 'MEDICAL_OFFICE' && userModel.currentUser.userType === Enum.USER_TYPE.DOCTOR));
            };
        }

        function configureInterface() {
        }

        function initialize() {

        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
